<template lang="pug">
  v-container.align-content-start(fill-height)
    h1 TRIP LIST
      v-progress-circular.ml-4.mb-1(v-if="loading" color="primary" indeterminate size="20")
    v-tabs.mt-2(grow background-color="#fafafa" v-model="tab")
      v-tab Upcoming
      v-tab Past
    v-row.mt-2(v-for="trip in filteredTrips" :key="trip.trip_id")
      v-col
        trip-item(:trip="trip")
    v-row.mt-10(v-if="filteredTrips.length === 0")
      v-col
        p.text-center {{ tab === 0 ? 'No Upcoming Trip' : 'No Past Trip' }}
</template>

<script>
import parse from 'date-fns/parse'
import TripItem from '@/components/TripItem'

export default {
  name: 'Home',
  components: { TripItem },
  data: () => ({
    loading: true,
    trips: [],
    tab: 0
  }),
  computed: {
    user () {
      return this.$store.state.user
    },
    upcomingTrips () {
      return this.trips.filter(t => {
        var result = parse(t.return_date, 'dd/MM/yyyy', new Date())
        return new Date() < result
      })
    },
    pastTrips () {
      return this.trips.filter(t => {
        var result = parse(t.return_date, 'dd/MM/yyyy', new Date())
        return new Date() > result
      })
    },
    filteredTrips () {
      return this.tab === 0 ? this.upcomingTrips : this.pastTrips
    }
  },
  watch: {
    user: {
      immediate: true,
      handler(val, oldVal) {
        if (val) {
          this.fetchTrips(val)
        }
      }
    }
  },
  methods: {
    fetchTrips (user) {
      this.$axios.get(`/trips/?tg_id=${user.tg_id}`)
        .then(resp => {
          this.trips = resp.data.trips
          this.loading = false
        })
    }
  }
};
</script>
